import classNames from 'classnames'
import isMobile from 'shared/responsive-helpers'
import Icon from '@components/Icon'
import './styles.scss'

const Price = ({ oldPrice, price }) => (
    <>
        {oldPrice && <span className="list-item__price list-item__price--old">{oldPrice}</span>}
        <span className="list-item__price">{price}</span>
    </>
)

const ListItem = ({
    isActive = false,
    disabled = false,
    onClick,
    title,
    description,
    price,
    oldPrice,
    errorMessage,
    shortDescription,
}) => (
    <li
        className={classNames('list-item', {
            active: isActive,
            disabled: disabled,
        })}
        onClick={onClick}>
        <span className="list-item__checkmark" />
        <div className="flex-column mr-auto w-100">
            <span className="list-item__title">{title}</span>
            {isMobile() && (
                <>
                    <Price price={price} oldPrice={oldPrice} />
                    {shortDescription && <p className="text-small">{shortDescription}</p>}
                </>
            )}
            {description && <p className="list-item__description">{description}</p>}
            {errorMessage && (
                <div className="d-flex">
                    <Icon className="list-item__error-icon" type="alert" size="xs" />
                    <span className="list-item__error-message">{errorMessage}</span>
                </div>
            )}
        </div>
        {!isMobile() && (
            <div className="text-nowrap text-right">
                <Price price={price} oldPrice={oldPrice} />
                {shortDescription && <p className="text-small">{shortDescription}</p>}
            </div>
        )}
    </li>
)

ListItem.propTypes = {
    isActive: PropTypes.bool,
    disabled: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    description: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    price: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    oldPrice: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    errorMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
}

export { ListItem }
